import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/电影",
    icon: "ri-movie-2-line",
    title: "电影频道",
    desc: "院线大片与口碑佳作",
    color: "bg-primary-500 text-background-50",
    iconBg: "bg-background-50/15",
  },
  {
    to: "/category/电视剧",
    icon: "ri-live-line",
    title: "电视剧频道",
    desc: "热播剧集与经典长剧",
    color: "bg-accent-500 text-background-50",
    iconBg: "bg-background-50/20",
  },
  {
    to: "/search?q=悬疑",
    icon: "ri-search-eye-line",
    title: "悬疑推理",
    desc: "反转不断 烧脑上头",
    color: "bg-secondary-700 text-background-50",
    iconBg: "bg-background-50/15",
  },
  {
    to: "/category/全部",
    icon: "ri-grid-fill",
    title: "全部影视",
    desc: "按类型地区年份筛选",
    color: "bg-foreground-900 text-background-50",
    iconBg: "bg-background-50/15",
  },
];

export default function CategoryEntry() {
  return (
    <section className="w-full px-4 md:px-8 py-8 md:py-10">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-5">
        {entries.map((item) => (
          <Link
            key={item.to}
            to={item.to}
            className={`group flex items-center gap-3 md:gap-4 p-4 md:p-5 rounded-lg ${item.color} transition-transform duration-300 hover:-translate-y-1 cursor-pointer`}
          >
            <span className={`w-11 h-11 md:w-12 md:h-12 flex items-center justify-center rounded-lg ${item.iconBg} shrink-0`}>
              <i className={`${item.icon} text-xl md:text-2xl`} />
            </span>
            <div className="min-w-0">
              <h3 className="font-heading text-sm md:text-base font-bold truncate">{item.title}</h3>
              <p className="text-xs opacity-80 truncate hidden sm:block">{item.desc}</p>
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}